import React from "react";
import "./DeleteAccount.css";
import Logo from "../assets/images/takeStock_logo.png";

const SUPPORT_EMAIL = "support@takestockinventory.com";
function DeleteAccount() {
  return (
    <div className="delete-account-page">
      <section className="delete-account-hero">
        <div className="delete-account-card">
          <img
            src={Logo}
            alt="TakeStock"
            className="delete-account-logo"
          />
          <p className="delete-account-kicker">TakeStock Account Deletion</p>
          <h3>Request deletion of your TakeStock account</h3>
          <p className="delete-account-lead">
            This page explains how TakeStock users can request deletion of
            their mobile app account and associated personal data.
          </p>
        </div>
      </section>

      <main className="delete-account-content">
        <section className="delete-account-section">
          <h2>How to request deletion</h2>
          <ol>
            <li>Sign in to the TakeStock mobile app.</li>
            <li>Go to Account Settings.</li>
            <li>Select Delete Account and confirm your request.</li>
          </ol>
          <p>
            If you cannot access the app, contact{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> from your
            registered email address and include "Delete My Account" in the
            subject line.
          </p>
        </section>

        <section className="delete-account-section">
          <h2>What is deleted</h2>
          <ul>
            <li>Your TakeStock mobile account access is disabled.</li>
            <li>Your profile and authentication records are marked for deletion.</li>
            <li>You will no longer be able to sign in with that account.</li>
          </ul>
        </section>

        <section className="delete-account-section">
          <h2>What may be retained</h2>
          <ul>
            <li>Subscription, billing, and payment-related records where retention is legally required.</li>
            <li>Security, fraud-prevention, and audit logs needed to protect the service.</li>
            <li>Records that must be preserved to comply with contractual or regulatory obligations.</li>
          </ul>
        </section>

        <section className="delete-account-section">
          <h2>Retention period</h2>
          <p>
            When you confirm account deletion, your TakeStock account is
            deactivated and marked for deletion immediately. Any data that must
            be retained for legal, security, billing, or financial compliance
            purposes is kept only for the period required by those obligations.
          </p>
        </section>
      </main>
    </div>
  );
}

export default DeleteAccount;
